import Request from '../../utils/request'

export default {
  listar ({commit}) {
    return new Promise((resolve, reject) => {
      Request.get('/mensagens_ajuda/listar')
        .then(response => {
          commit('SET_LISTA', response.body.corpo)

          resolve()
        })
        .catch(reject)
    })
  }

}
